// Auto-generated by migrate-vinted-data.js — 2026-04-25
// 68 groups · 612 total items

const vintedCategories = [
  {
    "title": "Femmes · Vêtements",
    "items": [
      "Manteaux et vestes",
      "Sweats et sweats à capuche",
      "Blazers et tailleurs",
      "Robes",
      "Jupes",
      "Jupes-shorts",
      "Hauts et t-shirts",
      "Jeans",
      "Pantalons et leggings",
      "Shorts",
      "Combinaisons et combishorts",
      "Maillots de bain",
      "Lingerie et pyjamas",
      "Maternité",
      "Vêtements de sport",
      "Costumes et tenues particulières",
      "Autres"
    ]
  },
  {
    "title": "Femmes · Chaussures",
    "items": [
      "Ballerines",
      "Mocassins et chaussures bateau",
      "Bottes",
      "Mules et sabots",
      "Espadrilles",
      "Claquettes et tongs",
      "Chaussures à talons",
      "Chaussures à lacets",
      "Babies et Mary-Jane",
      "Sandales",
      "Chaussons et pantoufles",
      "Chaussures de sport",
      "Baskets"
    ]
  },
  {
    "title": "Femmes · Sacs",
    "items": [
      "Sacs à dos",
      "Sacs de plage",
      "Mallettes",
      "Sacs seau",
      "Sacs banane",
      "Pochettes",
      "Housses pour vêtements",
      "Sacs de sport",
      "Sacs à main",
      "Besaces",
      "Fourre-tout et sacs marins",
      "Sacs de voyage",
      "Trousses à maquillage",
      "Cartables et sacoches",
      "Sacs à bandoulière",
      "Sacs fourre-tout",
      "Porte-monnaie",
      "Wristlets"
    ]
  },
  {
    "title": "Femmes · Accessoires",
    "items": [
      "Bandanas et foulards pour cheveux",
      "Ceintures",
      "Gants",
      "Accessoires pour cheveux",
      "Mouchoirs de poche",
      "Chapeaux & casquettes",
      "Bijoux",
      "Porte-clés",
      "Écharpes et châles",
      "Lunettes de soleil",
      "Parapluies",
      "Montres",
      "Autres accessoires"
    ]
  },
  {
    "title": "Femmes · Beauté",
    "items": [
      "Maquillage",
      "Parfums",
      "Soins du visage",
      "Accessoires de beauté",
      "Soin mains",
      "Manucure",
      "Soins du corps",
      "Soins cheveux",
      "Autres cosmétiques et accessoires"
    ]
  },
  {
    "title": "Hommes · Vêtements",
    "items": [
      "Jeans",
      "Manteaux et vestes",
      "Hauts et t-shirts",
      "Costumes et blazers",
      "Sweats et pulls",
      "Pantalons",
      "Shorts",
      "Sous-vêtements et chaussettes",
      "Pyjamas",
      "Maillots de bain",
      "Vêtements de sport et accessoires",
      "Vêtements spécialisés et costumes",
      "Autres"
    ]
  },
  {
    "title": "Hommes · Chaussures",
    "items": [
      "Mocassins et chaussures bateau",
      "Bottes",
      "Mules et sabots",
      "Espadrilles",
      "Claquettes et tongs",
      "Chaussures habillées",
      "Sandales",
      "Chaussons et pantoufles",
      "Chaussures de sport",
      "Baskets"
    ]
  },
  {
    "title": "Hommes · Accessoires",
    "items": [
      "Sacs et sacoches",
      "Bandanas et foulards pour cheveux",
      "Ceintures",
      "Bretelles",
      "Gants",
      "Mouchoirs de poche",
      "Chapeaux et casquettes",
      "Bijoux",
      "Pochettes de costume",
      "Écharpes et châles",
      "Lunettes de soleil",
      "Cravates et nœuds papillons",
      "Montres",
      "Autres"
    ]
  },
  {
    "title": "Hommes · Soins",
    "items": [
      "Soins visage",
      "Accessoires",
      "Soins cheveux",
      "Soins du corps",
      "Soins mains et ongles",
      "Parfums",
      "Maquillage",
      "Coffrets",
      "Autres cosmétiques"
    ]
  },
  {
    "title": "Enfants · Vêtements pour filles",
    "items": [
      "Bébé filles",
      "Chaussures",
      "Vêtements d'extérieur",
      "Pulls & sweats",
      "Chemises et t-shirts",
      "Robes",
      "Jupes",
      "Pantalons et shorts",
      "Sacs et sacs à dos",
      "Accessoires",
      "Équipements de natation",
      "Sous-vêtements",
      "Pyjamas et chemises de nuit",
      "Vêtements de sport",
      "Lots de vêtements",
      "Jumeaux et plus",
      "Déguisements",
      "Tenues de soirée",
      "Autres"
    ]
  },
  {
    "title": "Enfants · Vêtements pour garçons",
    "items": [
      "Bébé garçons",
      "Chaussures",
      "Vêtements d'extérieur",
      "Pulls & sweats",
      "Chemises et t-shirts",
      "Pantalons et shorts",
      "Sacs et sacs à dos",
      "Accessoires",
      "Équipements de natation",
      "Sous-vêtements",
      "Pyjamas",
      "Vêtements de sport",
      "Lots de vêtements",
      "Jumeaux et plus",
      "Déguisements",
      "Tenues de soirée",
      "Autres"
    ]
  },
  {
    "title": "Enfants · Jeux et jouets",
    "items": [
      "Figurines et accessoires",
      "Loisirs créatifs",
      "Activités et jouets pour bébé",
      "Jeux de construction",
      "Poupées, poupons et accessoires",
      "Déguisements et jeux de rôle",
      "Jeux éducatifs",
      "Jeux et jouets électroniques",
      "Jeux/jouets musicaux et instruments",
      "Jeux de cirque, fidgets et gadgets",
      "Jeux de sport et de plein air",
      "Peluches",
      "Voitures, trains et autres véhicules"
    ]
  },
  {
    "title": "Enfants · Poussettes, porte-bébé et sièges auto",
    "items": [
      "Porte-bébé et écharpes",
      "Poussettes et landaus",
      "Accessoires de poussette",
      "Sièges auto",
      "Rehausseurs",
      "Accessoires pour siège auto"
    ]
  },
  {
    "title": "Enfants · Meubles et décoration",
    "items": [
      "Matelas pour lits bébé et enfant",
      "Tapis de sol et dalles en mousse",
      "Parcs",
      "Réducteurs de lit",
      "Décoration et souvenirs",
      "Chambre de bébé",
      "Tapis",
      "Chaises et fauteuils",
      "Modules de motricité",
      "Étagères",
      "Tables et bureaux",
      "Armoires"
    ]
  },
  {
    "title": "Enfants · Bain et change",
    "items": [
      "Sacs à langer",
      "Bain",
      "Changing mats & covers",
      "Couches",
      "Poubelles et rangements pour couches",
      "Pots et réducteurs",
      "Hygiène et soin",
      "Marchepieds"
    ]
  },
  {
    "title": "Enfants · Sécurité bébé et enfant",
    "items": [
      "Barrières de sécurité",
      "Accessoires de sécurité",
      "Protections auditives",
      "Laisses et harnais"
    ]
  },
  {
    "title": "Enfants · Santé et grossesse",
    "items": [
      "Humidificateurs",
      "Mouche-bébé",
      "Soins du post-partum",
      "Coussins de grossesse",
      "Pregnancy support belts",
      "Balances",
      "Thermomètres"
    ]
  },
  {
    "title": "Enfants · Allaitement et alimentation",
    "items": [
      "Mixeurs et robots cuiseurs pour bébé",
      "Bavoirs",
      "Alimentation au biberon",
      "Allaitement",
      "Repas de bébé",
      "Coussins et couvertures d'allaitement",
      "Sucettes",
      "Accessoires pour sucettes",
      "Chaises hautes",
      "Accessoires pour chaise haute",
      "Langes",
      "Stérilisateurs"
    ]
  },
  {
    "title": "Enfants · Sommeil et literie",
    "items": [
      "Babyphones",
      "Barrières de lit",
      "Linge de lit, couvertures et plaids",
      "Stores occultants",
      "Coussins chauffants et bouillottes",
      "Veilleuses",
      "Gigoteuses et turbulettes",
      "Sacs de couchage",
      "Couvertures d'emmaillotage",
      "Générateurs de bruits blancs"
    ]
  },
  {
    "title": "Enfants · Fournitures scolaires",
    "items": [
      "Boîtes et sacs à repas",
      "Cartables",
      "Fournitures scolaires"
    ]
  },
  {
    "title": "Enfants",
    "items": [
      "Autres articles pour bébé et enfant"
    ]
  },
  {
    "title": "Maison · Petits appareils de cuisine",
    "items": [
      "Bouilloires",
      "Préparation du café, du thé et de l'expresso",
      "Grille-pain",
      "Blenders, mixeurs et robots de cuisine",
      "Micro-ondes",
      "Friteuses",
      "Plaques de cuisson",
      "Grils et planchas",
      "Extracteurs de jus",
      "Distributeurs d'eau et de boissons",
      "Appareils spécialisés",
      "Accessoires pour petits appareils de cuisine",
      "Pièces détachées pour petits appareils de cuisine"
    ]
  },
  {
    "title": "Maison · Cuisson et pâtisserie",
    "items": [
      "Casseroles",
      "Poêles",
      "Plaques pour la cuisson",
      "Plats pour le four",
      "Moules de cuisson",
      "Matériel de cuisson et de pâtisserie spécialisé",
      "Batteries de cuisine",
      "Accessoires pour la cuisine et la pâtisserie"
    ]
  },
  {
    "title": "Maison · Outils de cuisine",
    "items": [
      "Planches à découper",
      "Ustensiles de cuisine",
      "Balances de cuisine",
      "Tasses et cuillères à mesurer",
      "Thermomètres alimentaires",
      "Bols à mélanger",
      "Passoires, tamis et chinois",
      "Stockage alimentaire",
      "Accessoires de bar",
      "Ustensiles de cuisine spécialisés"
    ]
  },
  {
    "title": "Maison · Arts de la table",
    "items": [
      "Couverts",
      "Vaisselle",
      "Verres",
      "Vaisselle de service"
    ]
  },
  {
    "title": "Maison · Entretien de la maison",
    "items": [
      "Chauffage, climatisation et ventilation",
      "Fers à repasser et entretien du linge",
      "Aspirateurs et nettoyage"
    ]
  },
  {
    "title": "Maison · Textiles",
    "items": [
      "Linge de lit",
      "Couvertures",
      "Rideaux et stores",
      "Coussins décoratifs",
      "Housses",
      "Tapis",
      "Linge de table",
      "Tapisseries",
      "Serviettes"
    ]
  },
  {
    "title": "Maison · Décoration",
    "items": [
      "Bougies et parfums d'ambiance",
      "Horloges",
      "Sculptures et figurines",
      "Accessoires décoratifs",
      "Plantes et fleurs artificielles",
      "Accessoires pour cheminées",
      "Éclairage",
      "Étagères murales",
      "Encadrements",
      "Miroirs",
      "Rangement et organisation",
      "Vases",
      "Décorations murales"
    ]
  },
  {
    "title": "Maison · Fournitures de bureau",
    "items": [
      "Agendas et organiseurs",
      "Carnets et blocs-notes",
      "Trousses",
      "Marque-pages",
      "Calculatrices",
      "Accessoires de bureau",
      "Organiseurs de documents",
      "Fournitures d'écriture",
      "Outils de dessin technique",
      "Rubans adhésifs, pinces et attaches",
      "Agrafeuses et perforatrices",
      "Matériel de présentation",
      "Matériel électronique de bureau",
      "Coffres-forts"
    ]
  },
  {
    "title": "Maison · Célébrations et fêtes",
    "items": [
      "Banderoles, drapeaux et guirlandes",
      "Cartes et enveloppes",
      "Papier cadeau et sacs",
      "Décorations saisonnières",
      "Accessoires de fête",
      "Décorations de table",
      "Décorations pour le sapin",
      "Couronnes"
    ]
  },
  {
    "title": "Maison · Outils et bricolage",
    "items": [
      "Outils électriques",
      "Outils à main",
      "Outils de mesure",
      "Outils et accessoires de peinture",
      "Outils de plomberie",
      "Outils d'électricien",
      "Outils de maçonnerie",
      "Accessoires pour outils",
      "Équipement de protection",
      "Transport et rangement des outils",
      "Équipement d'atelier et de chantier",
      "Quincaillerie",
      "Maisons connectées et sécurité"
    ]
  },
  {
    "title": "Maison · Extérieur et jardin",
    "items": [
      "Outils électriques d'extérieur",
      "Accessoires pour outils électriques d'extérieur",
      "Outils manuels de jardin",
      "Pots, jardinières et accessoires",
      "Équipement d'arrosage",
      "Décorations de jardin et d'extérieur",
      "Cuisine et grillade d'extérieur",
      "Spas, piscines et équipements",
      "Instruments météorologiques",
      "Outils de déneigement"
    ]
  },
  {
    "title": "Maison · Animaux",
    "items": [
      "Chiens",
      "Chats",
      "Rongeurs & co",
      "Poissons",
      "Oiseaux",
      "Reptiles"
    ]
  },
  {
    "title": "Électronique · Jeux vidéo et consoles",
    "items": [
      "Consoles",
      "Jeux",
      "Manettes",
      "Casques gaming",
      "Simulateurs",
      "Réalité virtuelle",
      "Accessoires"
    ]
  },
  {
    "title": "Électronique · Ordinateurs et accessoires",
    "items": [
      "Ordinateurs portables",
      "Ordinateurs de bureau",
      "Pièces détachées et composants informatiques",
      "Supports vierges",
      "Accessoires informatiques",
      "Accessoires pour ordinateurs portables",
      "Stations d'accueil et concentrateurs USB",
      "Claviers et accessoires",
      "Souris",
      "Tapis de souris",
      "Moniteurs et accessoires",
      "Haut-parleurs pour ordinateurs",
      "Microphones d'ordinateur",
      "Webcams",
      "Équipements réseau",
      "Imprimantes et accessoires",
      "Scanners et accessoires",
      "Tablettes tactiles et tablettes à stylets"
    ]
  },
  {
    "title": "Électronique · Téléphones portables et équipements de communication",
    "items": [
      "Téléphones portables",
      "Pièces de rechange et accessoires pour téléphones portables",
      "Téléphones fixes",
      "Fax",
      "Communication radio",
      "Téléphones portables factices"
    ]
  },
  {
    "title": "Électronique · Audio, casques et hi-fi",
    "items": [
      "Casques audio et écouteurs",
      "Lecteurs de musique portables",
      "Radios portables",
      "Enceintes portables",
      "Enceintes connectées",
      "Systèmes audio domestiques",
      "Accessoires pour appareils audio",
      "Pièces de rechange pour appareils hi-fi et audio domestiques"
    ]
  },
  {
    "title": "Électronique · Appareils photo et accessoires",
    "items": [
      "Appareils photo",
      "Objectifs",
      "Flashs",
      "Cartes mémoire",
      "Trépieds et monopodes",
      "Stabilisateurs et supports",
      "Équipements pour chambres noires",
      "Équipement pour studio",
      "Drones et accessoires",
      "Accessoires",
      "Pièces de rechange pour appareils photo",
      "Autre matériel de photographie"
    ]
  },
  {
    "title": "Électronique · Tablettes, liseuses et accessoires",
    "items": [
      "Tablettes",
      "Liseuses",
      "Blocs-notes numériques",
      "Assistants personnels",
      "Accessoires"
    ]
  },
  {
    "title": "Électronique · TV et home cinema",
    "items": [
      "Téléviseurs",
      "Projecteurs",
      "Passerelles multimédias",
      "Antennes de télévision",
      "Antennes paraboliques",
      "Décodeurs vidéo",
      "Récepteurs de télévision",
      "Systèmes de home cinema",
      "Lecteurs Blu-ray",
      "Lecteurs DVD",
      "Magnétoscopes",
      "Autres appareils de lecture vidéo",
      "Accessoires TV et home cinema"
    ]
  },
  {
    "title": "Électronique · Produits de beauté et de soins personnels",
    "items": [
      "Appareils de coiffure",
      "Appareils de beauté",
      "Rasage et épilation",
      "Appareils de massage",
      "Appareils d'hygiène bucco-dentaire",
      "Appareils de soin des ongles",
      "Pèse-personnes"
    ]
  },
  {
    "title": "Électronique · Objets connectés",
    "items": [
      "Montres connectées",
      "Bracelets connectés",
      "Lunettes connectées",
      "Bagues connectées",
      "Bracelets de remplacement",
      "Coques pour montres connectées"
    ]
  },
  {
    "title": "Électronique · Autres appareils et accessoires",
    "items": [
      "Impression et numérisation 3D",
      "GPS et appareils de navigation par satellite",
      "Localisateurs d'objets",
      "Pèse-bagages",
      "Adaptateurs",
      "Câbles",
      "Chargeurs",
      "Batteries externes",
      "Multiprises parasurtenseurs",
      "Piles et alimentations",
      "Autres accessoires"
    ]
  },
  {
    "title": "Divertissement · Livres",
    "items": [
      "Fiction",
      "Non-fiction",
      "Enfants et jeunes adultes",
      "Bandes dessinées, mangas et romans graphiques",
      "Manuels scolaires et ressources pédagogiques",
      "Livres de coloriage et d'activités et revues de jeux"
    ]
  },
  {
    "title": "Divertissement",
    "items": [
      "Magazines"
    ]
  },
  {
    "title": "Divertissement · Musique",
    "items": [
      "Cassettes audio",
      "CD",
      "MiniDiscs",
      "Vinyles"
    ]
  },
  {
    "title": "Divertissement · Vidéo",
    "items": [
      "Blu-ray 4K",
      "Betamax",
      "Blu-ray",
      "DVD",
      "HD DVD",
      "LaserDisc",
      "VHS"
    ]
  },
  {
    "title": "Loisirs et collections · Cartes à collectionner",
    "items": [
      "Cartes à collectionner à l'unité",
      "Boosters",
      "Coffrets de boosters",
      "Jeux de cartes",
      "Lots de cartes à collectionner",
      "Cartes non découpées"
    ]
  },
  {
    "title": "Loisirs et collections",
    "items": [
      "Jeux de société",
      "Puzzles",
      "Jeux de plateau et jeux miniatures",
      "Cartes postales"
    ]
  },
  {
    "title": "Loisirs et collections · Souvenirs",
    "items": [
      "Souvenirs de sport",
      "Souvenirs de musique",
      "Souvenirs TV et cinéma",
      "Autres souvenirs"
    ]
  },
  {
    "title": "Loisirs et collections · Pièces de monnaie et billets",
    "items": [
      "Billets",
      "Pièces de monnaie",
      "Lots",
      "Médailles et jetons",
      "Titres et actions"
    ]
  },
  {
    "title": "Loisirs et collections · Timbres",
    "items": [
      "Timbres à l'unité",
      "Lots de timbres",
      "Enveloppes premier jour",
      "Catalogues et guides de timbres",
      "Outils et matériel pour timbres"
    ]
  },
  {
    "title": "Loisirs et collections · Instruments de musique et équipement",
    "items": [
      "Guitares et basses",
      "Amplis et pédales",
      "Batterie et percussions",
      "Claviers et synthétiseurs",
      "Instruments à cordes",
      "Instruments à vent",
      "Matériel de studio et sonorisation live",
      "Équipement DJ",
      "Équipement de karaoké",
      "Accessoires pour la création musicale"
    ]
  },
  {
    "title": "Loisirs et collections · Loisirs créatifs",
    "items": [
      "Couture, tricot et travaux d'aiguille",
      "Peinture",
      "Dessin et esquisse",
      "Calligraphie",
      "Fabrication de bijoux",
      "Papercraft",
      "Découpe",
      "Fabrication de bougies",
      "Sculpture et poterie",
      "Fournitures pour loisirs créatifs",
      "Outils pour loisirs créatifs"
    ]
  },
  {
    "title": "Loisirs et collections · Rangements pour objets de collection",
    "items": [
      "Albums et classeurs",
      "Boîtes de rangement",
      "Protège-cartes souples",
      "Protège-cartes rigides",
      "Boîtes pour jeux de cartes",
      "Intercalaires pour albums et classeurs",
      "Recharges pour albums et classeurs",
      "Tapis de puzzle",
      "Autres rangements"
    ]
  },
  {
    "title": "Loisirs et collections · Accessoires de jeux",
    "items": [
      "Dés",
      "Jetons et marqueurs de jeu",
      "Tapis de jeux",
      "Autres accessoires de jeux"
    ]
  },
  {
    "title": "Sport · Cyclisme",
    "items": [
      "Vélos pour enfant",
      "Casques de vélo",
      "Accessoires et outils pour vélo",
      "Remorques pour vélo",
      "Sièges enfants pour vélo",
      "Pièces pour vélo"
    ]
  },
  {
    "title": "Sport · Fitness, course à pied et yoga",
    "items": [
      "Musculation",
      "Course à pied",
      "Matériel de yoga et de pilates",
      "Accessoires de fitness à domicile",
      "Gourdes"
    ]
  },
  {
    "title": "Sport · Sports de plein air",
    "items": [
      "Escalade et escalade de bloc",
      "Tentes et matériel de couchage",
      "Réchauds et ustensiles de cuisine de camping",
      "Jumelles et longues-vues",
      "Glacières",
      "Systèmes et kits d'hydratation",
      "Meubles de camping",
      "Torches, lampes frontales et lanternes",
      "Bâtons de randonnée",
      "Boussoles",
      "Sacs de randonnée",
      "Pêche et chasse",
      "Autres accessoires de sports de plein air"
    ]
  },
  {
    "title": "Sport · Sports nautiques",
    "items": [
      "Natation",
      "Bateaux gonflables",
      "Kayaks",
      "Planches de kitesurf",
      "Skimboards",
      "Paddles",
      "Bouées tractées",
      "Planches de wakeboard",
      "Skis nautiques",
      "Gilets de flottaison",
      "Casques pour sports nautiques",
      "Combinaisons, gants et chaussons",
      "Accessoires pour sports nautiques"
    ]
  },
  {
    "title": "Sport · Sports d'équipe",
    "items": [
      "Football",
      "Basketball",
      "Volley-ball",
      "Rugby",
      "Matériel d'entraînement et d'arbitrage",
      "Football américain",
      "Baseball et softball",
      "Handball",
      "Cricket",
      "Hockey sur gazon",
      "Floorball",
      "Sports gaéliques",
      "Lacrosse",
      "Netball",
      "Autres équipements pour sports d'équipe"
    ]
  },
  {
    "title": "Sport · Sports de raquette",
    "items": [
      "Tennis",
      "Squash",
      "Badminton",
      "Racquetball",
      "Tennis de table",
      "Padel",
      "Pickleball",
      "Lunettes pour sports de raquette"
    ]
  },
  {
    "title": "Sport · Golf",
    "items": [
      "Accessoires de golf",
      "Sacs de golf",
      "Balles de golf",
      "Clubs de golf",
      "Gants de golf",
      "Chariots de golf",
      "Matériel d'entraînement pour le golf"
    ]
  },
  {
    "title": "Sport · Équitation",
    "items": [
      "Protections d'équitation",
      "Gants d'équitation",
      "Bombes d'équitation",
      "Couvre-casques d'équitation",
      "Selles et harnachement"
    ]
  },
  {
    "title": "Sport · Skateboards et trottinettes",
    "items": [
      "Longboards",
      "Skateboards",
      "Trottinettes",
      "Casques de skate",
      "Protections de skate",
      "Pièces et accessoires pour skating",
      "Pièces et accessoires pour skateboard"
    ]
  },
  {
    "title": "Sport · Boxe et arts martiaux",
    "items": [
      "Protections pour la tête",
      "Protections pour le corps",
      "Pattes d'ours, pao et boucliers",
      "Gants de boxe et d'arts martiaux",
      "Bandes de boxe",
      "Ceintures d'arts martiaux",
      "Sacs de frappe",
      "Poires de vitesse",
      "Autres équipements pour arts martiaux"
    ]
  },
  {
    "title": "Sport · Sports et jeux de loisir",
    "items": [
      "Pétanque et autres jeux",
      "Matériel pour fléchettes",
      "Frisbee et disc golf",
      "Balles et ballons",
      "Billard et snooker",
      "Roundnet et spikeball",
      "Bowling"
    ]
  },
  {
    "title": "Sport · Sports d'hiver",
    "items": [
      "Matériel de ski",
      "Matériel de snowboard",
      "Hockey sur glace",
      "Accessoires de patinage artistique",
      "Luges",
      "Raquettes à neige",
      "Guêtres",
      "Masques et lunettes de ski",
      "Casques pour sports d'hiver"
    ]
  }
];

export default vintedCategories;
